module.exports = "/packs/arrow-down-027e0b1f8f4780e11cabcf245519a60b.svg";